import React from 'react';
import { theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ResultIconTile,
  ResultName,
  ResultSubtext,
  ResultText,
} from '../styles';
import { InteractiveResultRow } from './InteractiveResultRow';
import {
  CustomResourceIconConfig,
  fallbackCustomResourceIcon,
} from '../customResourceIcons';
import type { CustomResourceSearchHit } from '../types';

interface CustomResourceResultProps {
  result: CustomResourceSearchHit;
  resultRef?: React.Ref<HTMLDivElement>;
  onSelect?: (result: CustomResourceSearchHit) => void;
  icon?: CustomResourceIconConfig;
}

export const CustomResourceResult: React.FC<CustomResourceResultProps> = ({
  result,
  resultRef,
  onSelect,
  icon,
}) => {
  const { token } = theme.useToken();
  const location = [result.levelName, result.locationName]
    .filter(Boolean)
    .join(', ');
  const handleSelect = onSelect ? () => onSelect(result) : undefined;
  const { fontAwesome, customComponent: CustomIcon } =
    icon ?? fallbackCustomResourceIcon;

  return (
    <InteractiveResultRow resultRef={resultRef} onSelect={handleSelect}>
      <ResultIconTile
        aria-hidden="true"
        style={{ background: token.colorFillQuaternary }}
      >
        {CustomIcon ? (
          <CustomIcon data-testid="custom-resource-result-icon" />
        ) : fontAwesome ? (
          <FontAwesomeIcon
            data-testid="custom-resource-result-icon"
            icon={fontAwesome}
          />
        ) : null}
      </ResultIconTile>
      <ResultText>
        <ResultName>{result.displayName}</ResultName>
        {location && <ResultSubtext>{location}</ResultSubtext>}
      </ResultText>
    </InteractiveResultRow>
  );
};
